module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_6005.d184dc9d.png";